import { render, staticRenderFns } from "./TransactionPagination.vue?vue&type=template&id=22b03e55"
import script from "./TransactionPagination.vue?vue&type=script&lang=js"
export * from "./TransactionPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports